/**
 * Kleine Symbole der Listenzeilen (Dateien, Verknüpfungen): Lucide-Pfade als Inline-SVG, weil das Paket `lucide-react`
 * nicht selbst einbindet (wie `LeerZustand`). Alle `currentColor`, `aria-hidden`; die Bedeutung trägt der Text bzw. das
 * Label des Knopfs, nie das Symbol allein (R-F). Abweichung AW-014: Lucide-Symbole statt der Illustrationen und Symbole der
 * Katalogblöcke (Dateiliste, Verknüpfungsliste, Ablage).
 */
const SVG = {
  className: "shrink-0 size-4",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true as const,
};

export function SymbolPlus() {
  return (
    <>
      {/* Preline: data-display/data-display-sub-operational-activity-views/data-display-cat-file-views/profile-files-list (Symbol Lucide, Quelle des Blocks ersetzt) */}
      <svg {...SVG}>
        <path d="M5 12h14" />
        <path d="M12 5v14" />
      </svg>
    </>
  );
}

export function SymbolHochladen() {
  return (
    <>
      {/* Preline: forms/forms-sub-creation-management/forms-cat-file-upload-forms/dropzone-upload-form (Illustration des Blocks durch Lucide „upload“ ersetzt) */}
      <svg {...SVG}>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" x2="12" y1="3" y2="15" />
      </svg>
    </>
  );
}

export function SymbolHerunterladen() {
  return (
    <>
      {/* Preline: data-display/data-display-sub-operational-activity-views/data-display-cat-file-views/profile-files-list (Symbol Lucide „download“) */}
      <svg {...SVG}>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" x2="12" y1="15" y2="3" />
      </svg>
    </>
  );
}

export function SymbolPapierkorb() {
  return (
    <>
      {/* Preline: data-display/data-display-sub-operational-activity-views/data-display-cat-file-views/profile-files-list (Symbol Lucide „trash-2“) */}
      <svg {...SVG}>
        <path d="M3 6h18" />
        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
        <line x1="10" x2="10" y1="11" y2="17" />
        <line x1="14" x2="14" y1="11" y2="17" />
      </svg>
    </>
  );
}

export function SymbolEntfernen() {
  return (
    <>
      {/* Preline: data-display/data-display-sub-operational-activity-views/data-display-cat-list-groups/icon-action-list-with-dashed-dividers (Symbol Lucide „x“) */}
      <svg {...SVG}>
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </>
  );
}

/** Lade-Symbol (Lucide „loader-circle“), dreht sich; bei reduzierter Bewegung steht es still. */
export function SymbolLaedt() {
  return (
    <>
      {/* Preline: forms/forms-sub-creation-management/forms-cat-file-upload-forms/banner-image-upload-card (Fortschrittszeile; Symbol Lucide „loader-circle“) */}
      <svg {...SVG} className="shrink-0 size-4 animate-spin motion-reduce:animate-none">
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    </>
  );
}
